export default __webpack_public_path__ + "static/media/source_code_leakage.6544532b.svg";